import classNames from "classnames";
import styles from "./styles.module.scss";
import { Spin } from "antd";

interface LoadingOverlayProps {
  isLoading: boolean;
  taskStatus?: string;
}

export const LoadingOverlay = ({
  isLoading,
  taskStatus,
}: LoadingOverlayProps) => {
  if (!isLoading) return null;

  return (
    <div className={classNames(styles.overlay)}>
      <div className={styles.spin}>
        <h2>
          Generating: <span>{taskStatus ? `${taskStatus}` : ""}</span>
        </h2>
        <Spin size="large" />
      </div>
    </div>
  );
};
